import { TmBaseError } from '@/core/error/tmBaseError'

export class TmNotImplementedError extends TmBaseError {
  public name = 'TmNotImplementedError'
}
